'use strict';

const BlockRandomizationAction = require('./BlockRandomization');
const DisableAction = require('./Disable');
const ErrorAction = require('./Error');
const FilterAction = require('./Filter');
const HideAction = require('./Hide');
const HideChildrenAction = require('./HideChildren');
const MessageAction = require('./Message');
const QueryAction = require('./Query');
const SetValueAction = require('./SetValue');
const NotificationAction = require('./Notification');
const EnableEproAction = require('./EnableEpro');

/**
 * @constructs Structure.Action
 */
class ActionFactory {
    /**
     * A partir de un objeto de definición instancia la clase correspondiente para gestionar una acción
     *
     * @param  {object}           rawAction Definición de la acción
     *
     * @return {Structure.Action}            Acción creada
     *
     * @throws {Error} Si el identificador del tipo de acción no se reconoce
     */
    static instantiateAction(rawAction) {
        switch (rawAction.type) {
            case 'blockRandomization':
                return BlockRandomizationAction.instance(rawAction);
            case 'disable':
                return new DisableAction(rawAction);
            case 'error':
                return new ErrorAction(rawAction);
            case 'filter':
                return new FilterAction(rawAction);
            case 'hide':
                return new HideAction(rawAction);
            case 'hideChildren':
                return new HideChildrenAction(rawAction);
            case 'message':
                return new MessageAction(rawAction);
            case 'notification':
                return NotificationAction.instance(rawAction);
            case 'query':
                return new QueryAction(rawAction);
            case 'setValue':
                return new SetValueAction(rawAction);
            case 'enableEpro':
                return new EnableEproAction(rawAction);
        }

        throw new Error(`Tipo de acción de regla desconocido: "${rawAction.type}"`);
    }
}

module.exports = ActionFactory;
